import { render, staticRenderFns } from "./DocumentsPage.vue?vue&type=template&id=3ebb8453&scoped=true&"
import script from "./DocumentsPage.vue?vue&type=script&lang=js&"
export * from "./DocumentsPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsPage.vue?vue&type=style&index=0&id=3ebb8453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb8453",
  null
  
)

export default component.exports